import styles from 'src/pages/PaymentBetaPage/components/CheckoutSection/CheckoutSection.module.scss';
import { LoadingPanel } from 'src/pages/PaymentBetaPage/components/LoadingPanel';
import { PanelHeader } from 'src/pages/PaymentBetaPage/components/PanelHeader';
import { CheckoutSeatsSection } from 'src/v2/pages/payment/components/CheckoutSeatsSection';
import { SummarySection } from 'src/pages/PaymentBetaPage/components/SummarySection';
import { PayPalElements } from 'src/pages/PaymentBetaPage/components/PayPalElements';
import { stripePromise } from 'src/utils';
import { Elements } from '@stripe/react-stripe-js';
import { useColorTheme, useTeamInfo } from 'src/hooks';
import { SubscriptionPlanInfo } from 'src/types';
import { StripeElementsUpdatePaymentMethod } from 'src/pages/UpdatePaymentPage/components/StripeElementsUpdatePaymentMethod';

type CheckoutUpdatePaymentMethodProps = {
  onClose: () => void;
  currentPlan?: SubscriptionPlanInfo;
  onPaymentProcessing: (value: boolean) => void;
};

export const CheckoutUpdatePaymentMethod = ({
  onClose,
  currentPlan,
  onPaymentProcessing,
}: CheckoutUpdatePaymentMethodProps) => {
  const { teamInfo, isTeamInfoLoading } = useTeamInfo();
  const { isDarkTheme } = useColorTheme();

  const numberOfSeats = teamInfo?.num_seats_total || 0;

  return (
    <div className={styles.root}>
      {isTeamInfoLoading && <LoadingPanel onClose={onClose} />}

      <PanelHeader onClose={onClose} />

      <div className={styles.mainContainer}>
        <CheckoutSeatsSection numberOfSeats={numberOfSeats} />
        <SummarySection
          currentPlan={currentPlan}
          isTeams={true}
          isLoading={false}
        />

        <div className={styles.paymentContainer}>
          <PayPalElements
            selectedPlan={currentPlan}
            onPaymentProcessing={onPaymentProcessing}
            numberOfSeats={numberOfSeats}
            isUpdatePayment
          />

          {stripePromise && (
            <Elements
              stripe={stripePromise}
              options={{
                mode: 'subscription',
                appearance: {
                  theme: isDarkTheme ? 'night' : 'stripe',
                  variables: {
                    borderRadius: '12px',
                  },
                },
                currency: 'usd',
                amount: (currentPlan?.total_due_amount || 1) * numberOfSeats,
              }}
            >
              <StripeElementsUpdatePaymentMethod
                selectedPlan={currentPlan}
                onPaymentProcessing={onPaymentProcessing}
                numberOfSeats={numberOfSeats}
              />
            </Elements>
          )}
        </div>
      </div>
    </div>
  );
};
